module.exports = __webpack_public_path__ + "static/media/css.1fcf13fa.png";